import React, { createContext, useState, useRef, useEffect } from "react";
import { VirtualGroupingOptionsToMap, VirtualGroupingVariation } from "./VirtualGrouping/VirtualGroupingModel";
interface VirtualGroupingContextProps {
  scrollPosition: number;
  setScrollPosition: React.Dispatch<React.SetStateAction<number>>;
  virtualGroupingVariationsRef: React.MutableRefObject<VirtualGroupingVariation[]>;
  virtualGroupingTileContainerRef: React.RefObject<HTMLDivElement>;
  isInitialPageLoadRef: React.MutableRefObject<boolean>;
  virtualGroupingTileSelectedRef: React.MutableRefObject<boolean | null>;
  virtualGroupingUpdatingFocus: (selected: boolean) => void;
  virtualGroupOptionsMap: VirtualGroupingOptionsToMap[];
  virtualGroupingMobileDialogRef: React.RefObject<HTMLDialogElement>;
}
interface VirtualGroupingProviderProps {
  children: React.ReactNode;
  virtualGroupOptionsMap: VirtualGroupingOptionsToMap[];
  currentVirtualGroupingDataArray?: VirtualGroupingVariation[];
}
const VirtualGroupingContext = createContext<VirtualGroupingContextProps>({
  virtualGroupingVariationsRef: {
    current: []
  },
  virtualGroupingTileContainerRef: {
    current: null
  },
  scrollPosition: 0,
  setScrollPosition: () => undefined,
  isInitialPageLoadRef: {
    current: false
  },
  virtualGroupingTileSelectedRef: {
    current: false
  },
  virtualGroupingUpdatingFocus: () => undefined,
  virtualGroupOptionsMap: [],
  virtualGroupingMobileDialogRef: {
    current: null
  }
});
const VirtualGroupingProvider = ({
  virtualGroupOptionsMap,
  children,
  currentVirtualGroupingDataArray = []
}: VirtualGroupingProviderProps) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const virtualGroupingVariationsRef = useRef<VirtualGroupingVariation[]>(currentVirtualGroupingDataArray);
  const virtualGroupingTileContainerRef = useRef<HTMLDivElement>(null);
  const isInitialPageLoadRef = useRef(false);
  const virtualGroupingTileSelectedRef = useRef<boolean | null>(false);
  const virtualGroupingMobileDialogRef = useRef<HTMLDialogElement>(null);
  const virtualGroupingUpdatingFocus = (selected: boolean) => {
    virtualGroupingTileSelectedRef.current = selected;
  };
  useEffect(() => {
    if (virtualGroupOptionsMap.length > 0 && virtualGroupingVariationsRef.current.length === 0) {
      virtualGroupOptionsMap.forEach(grouping => {
        virtualGroupingVariationsRef.current = [...grouping.variations];
      });
    }
  }, [virtualGroupOptionsMap]);
  const context = {
    scrollPosition,
    setScrollPosition,
    virtualGroupingVariationsRef,
    virtualGroupingTileContainerRef,
    isInitialPageLoadRef,
    virtualGroupingTileSelectedRef,
    virtualGroupingUpdatingFocus,
    virtualGroupOptionsMap,
    virtualGroupingMobileDialogRef
  };
  return <VirtualGroupingContext.Provider value={context} data-sentry-element="unknown" data-sentry-component="VirtualGroupingProvider" data-sentry-source-file="useVirtualGroupingContext.tsx">
      {children}
    </VirtualGroupingContext.Provider>;
};
export { VirtualGroupingContext, VirtualGroupingProvider };